import { render, staticRenderFns } from "./stockFilters.vue?vue&type=template&id=e95f0b06"
import script from "./stockFilters.vue?vue&type=script&lang=js"
export * from "./stockFilters.vue?vue&type=script&lang=js"
import style0 from "./stockFilters.vue?vue&type=style&index=0&id=e95f0b06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports